import { observable } from "mobx";

// Page-keyed filter/search state shared by the template list pages (Campaign, Email,
// Survey templates). pageKey is a FilterModelPageName value, also used as the
// sessionStorage key.
const templateFilterStore = observable({
  filterModelByPage: {},
  searchTextByPage: {},

  getFilterModel(pageKey) {
    return this.filterModelByPage[pageKey] || {};
  },

  getSearchText(pageKey) {
    return this.searchTextByPage[pageKey] || "";
  },

  setFilterModel(pageKey, filterModel) {
    this.filterModelByPage[pageKey] = filterModel;
    sessionStorage.setItem(pageKey, JSON.stringify(filterModel));
  },

  setSearchText(pageKey, searchText) {
    this.searchTextByPage[pageKey] = searchText;
  },

  restoreFilterModel(pageKey) {
    const raw = sessionStorage.getItem(pageKey);
    if (!raw) return null;
    const filterModel = JSON.parse(raw);
    this.filterModelByPage[pageKey] = filterModel;
    return filterModel;
  },

  clearFilters(pageKey) {
    this.filterModelByPage[pageKey] = {};
    this.searchTextByPage[pageKey] = "";
    sessionStorage.removeItem(pageKey);
  },

  // category has no ag-grid column filter (see doesCategoryFilterPass) - strip it
  // before handing the model to ag-grid's own setFilterModel
  stripCategoryFromFilterModel({ category, ...rest }) {
    return rest;
  },

  isCategoryFilterPresent(pageKey) {
    const selected = this.filterModelByPage[pageKey]?.category?.values;
    return !!(selected && selected.length > 0);
  },

  doesCategoryFilterPass(pageKey, categoryJson) {
    const selected = this.filterModelByPage[pageKey]?.category?.values;
    if (!selected || selected.length === 0) return true;

    let rowCategories = [];
    try {
      rowCategories = categoryJson ? JSON.parse(categoryJson) : [];
    } catch {
      rowCategories = [];
    }

    return selected.every(value => rowCategories.includes(value));
  },
});

export default templateFilterStore;
